module.exports = __webpack_public_path__ + "img/jifen7.12e2e930.png";